import Component from '@glimmer/component';

export default class SharedQuestionnaireSingleSelectReview extends Component {
  get lastIndex() {
    return this.args.answer.answers.length - 1;
  }
}
